import { Navigate } from "react-router-dom";

export default function Droits() {
  return <Navigate to="/comprendre?tab=droits" replace />;
}
